import { Grid, GridItem, Stack, Text, useColorModeValue } from '@chakra-ui/react';

import { QuoteVariantByQuoteId } from '../../utils/types';
import { RequestDraftNote } from '../RequestDraftNote';
import { QuoteVariantFlightSegment } from './QuoteVariantFlightSegment';

export type FlightSegmentWitAirports = QuoteVariantByQuoteId['flight_path'][0];

export const QuoteVariantFlightPath = ({ flightSegments }: { flightSegments: FlightSegmentWitAirports[] }) => {
  const bgBody = useColorModeValue('white', 'gray.600');
  const bgHeader = useColorModeValue('gray.50', 'gray.700');
  // Every leg on a variant belongs to the same quote.
  const quoteId = flightSegments?.[0]?.quote_id ?? undefined;

  const renderSegment = (segment: (typeof flightSegments)[0]) => (
    <QuoteVariantFlightSegment key={segment.id} segment={segment} />
  );

  return (
    <Stack w="full" spacing={0}>
      <Grid templateColumns="repeat(7, 1fr)" w="full" gap={1} py={1} px={4} bgColor={bgHeader} borderTopWidth={1}>
        <GridItem colSpan={2}>
          <Text textStyle="label">Departs</Text>
        </GridItem>
        <GridItem colSpan={2}>
          <Text textStyle="label">Arrives</Text>
        </GridItem>
        <GridItem colSpan={1}>
          <Text textStyle="label">Travel Time</Text>
        </GridItem>
        <GridItem colSpan={1}>
          <Text textStyle="label">Aircraft Type</Text>
        </GridItem>
        <GridItem colSpan={1}>
          <Text textStyle="label">Flight No.</Text>
        </GridItem>
      </Grid>
      <Grid templateColumns="repeat(7, 1fr)" w="full" gap={1} py={2} px={4} bgColor={bgBody}>
        {flightSegments.map(renderSegment)}
      </Grid>
      <RequestDraftNote flightSegments={flightSegments} quoteId={quoteId} />
    </Stack>
  );
};
